<template>
  <div class="open-bet-row">
    <div class="open-bet-row-header mt-1" :class="{ active: expand }" @click="expand = !expand">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="title">{{ $t('BetSlip.Bet Ticket') }}: #{{ openbet.TicketNumber }}</div>
          <div class="subtitle">
            {{ $t('Placed') }}:
            {{ $moment(openbet.PlacedDate).format('dddd, D MMMM YYYY, h:mmA') }}
          </div>
        </div>
        <i :class="'icon align-self-center ' + (expand ? 'icon-arrow-top' : 'icon-arrow-bottom')" />
      </div>
    </div>
    <transition name="expand">
      <div v-if="expand">
        <!-- TYPE -->
        <div class="open-bet-row-subheader" style="padding:5px 10px">
          {{ replaceAg(normalizeDetail(openbet.CompleteDescription)) }}
        </div>
        <!-- DETAILS -->
        <div class="open-bet-row-detail-row bg-white" style="padding:15px 10px"
          v-for="(_detail, index) in openbet.Detail" :key="'open-bet-detail:' + index">
          <div class="d-flex">
            <!--<span class="line-number" v-html="_detail.RotationNumber" v-if="_detail.RotationNumber"></span>-->
            <!--            <div class="flex-grow-1"></div>-->
            <span class="line-date">{{ $moment(_detail.GameDateTime).format('dddd, D MMMM YYYY, h:mmA') }}</span>
          </div>
          <div class="line-detail">
            <div class="row">
              <div class="col-9">
                {{ _detail.DetailDescription.split("~~")[0] }}
                <span>
                  {{ _detail.IdSport === "Baseball" && _detail.Pitcher ? ` ${_detail.Pitcher}` : "" }}
                </span>
              </div>
              <div class="col-3">
                {{
                    _detail.Odds.toString().includes(".") || _detail.Odds.toString().includes("/") ||
                      _detail.Odds.toString().includes("-") ? "" + _detail.Odds : "+" +
                    _detail.Odds
                }}
              </div>
            </div>
            <div class="row">
              <div class="col-12">{{ _detail.DetailDescription.split("~~")[1] }}</div>
            </div>
            <div class="row">
              <div class="col-12">{{ _detail.DetailDescription.split("~~")[2] }}</div>
            </div>
          </div>
        </div>
        <!-- RISK ROW -->
        <div class="bet-slip-line-subheader line-header light bg-white p- m-0">
          <span class="title">{{ $t('Risk') }} {{ openbet.OriginalRiskAmount }}</span>
          <span class="title">{{ $t('Win') }} {{ totalWinAmount(openbet) }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { normalizeDetail } from '@/views/history/history-utils';

export default {
  props: ['openbet'],
  data() {
    return {
      expand: false,
    };
  },
  methods: {
    normalizeDetail,
    totalWinAmount(bet) {
      let winAmount = parseFloat(bet.OriginalWinAmount.replace(/[^0-9\.]/g, ''));
      let riskAmount = parseFloat(bet.OriginalRiskAmount.replace(/[^0-9\.]/g, ''));
      let currency = bet.OriginalRiskAmount.replace(/[0-9\.]/g, '');
      return currency + '' + parseFloat(winAmount + riskAmount).toFixed(2);
    },
    replaceAg(val) {
      return val.replace('(AG)', '(JG)');
    },
  },
};
</script>

<style lang="scss" scoped>
.expand-enter-active,
.expand-leave-active {
  transition: opacity 0.2s;
}

.expand-enter,
.expand-leave-to {
  opacity: 0;
}
</style>
